"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HumeClient = void 0;
const Client_1 = require("../Client");
const ExpressionMeasurementClient_1 = require("./expressionMeasurement/ExpressionMeasurementClient");
class HumeClient extends Client_1.HumeClient {
    constructor(_options = {}) {
        super(_options);
        this._options = _options;
    }
    get expressionMeasurement() {
        var _a;
        return ((_a = this._expressionMeasurement) !== null && _a !== void 0 ? _a : (this._expressionMeasurement = new ExpressionMeasurementClient_1.ExpressionMeasurement(this._options)));
    }
}
exports.HumeClient = HumeClient;
